/** Explicit editor inputs win; FT3D keeps its encounter in the shared page context. */
export function generatorDestination(root: Element | Document = document, inputs: Record<string, string> = {}): string {
    for (const key of ['encounter_id', 'location_id']) {
        const id = inputs[key] ?? key;
        const element = (root === document ? null : root.querySelector<HTMLInputElement>(`[id="${id}"]`))
            ?? document.getElementById(id) as HTMLInputElement | null;
        const value = String(element?.value ?? '').trim();
        if (value) return value;
    }
    const context = window as Window & { ftGetActiveEncounterId?: () => unknown };
    return String(context.ftGetActiveEncounterId?.() ?? '').trim();
}
